<script>
export default {
  name: 'Terms',
  data() {
    return {
      currentDate: new Date().toLocaleDateString('ar-SA')
    };
  },
  head() {
    return {
      title: 'شروط وأحكام الاستخدام - زيتون'
    };
  }
};
</script>

<template>
  <MainLayout>
    <div class="max-w-4xl mx-auto mt-5 py-16 px-4 sm:px-6 lg:px-8">
      <div class="terms shadow-sm rounded-xl">
        <h1 class="text-3xl font-bold mb-6 text-right">الشروط والأحكام</h1>
        <p class="text-right mb-6 text-gray-700">
          الرجاء قراءة هذه الشروط والأحكام بعناية قبل استخدام الموقع.
        </p>
        <ol class="list-decimal list-inside space-y-4 d-flex flex-column gap-2 text-right text-gray-800">
          <li>
            <strong class="text-warning">الوصول إلى المحتوى:</strong> المحتوى المميز المتاح على هذا
            الموقع متاح فقط للأعضاء المسجلين والذين قاموا بتفعيل الإشتراك
            المدفوع بحسب الرسوم الموضحة عند التسجيل.
          </li>
          <li>
            <strong class="text-warning">معايير التسجيل:</strong> للتسجيل والإشتراك، يجب أن يكون
            الشخص في سن الرشد القانوني وأن يملك الصلاحيات الكاملة لإستخدام رقم
            الهاتف المقدم أثناء التسجيل.
          </li>
          <li>
            <strong class="text-warning">التكاليف والرسوم:</strong> سيتم خصم رسوم الإشتراك من حساب
            المشترك تلقائيا.
          </li>
          <li>
            <strong class="text-warning">تعديل الرسوم:</strong> تحتفظ إدارة الموقع بالحق في تعديل
            رسوم الإشتراك بحرية تامة، سواء بالزيادة أو النقصان.
          </li>
          <li>
            <strong class="text-warning">حق الإلغاء:</strong> يحق للمشترك إنهاء إشتراكه في أي وقت من
            خلال الخيارات المتاحة داخل الموقع.
          </li>
          <li>
            <strong class="text-warning">الحقوق الفكرية:</strong> جميع حقوق الملكية الفكرية للمحتوى
            المقدم تتبع للموقع، ومن غير المسموح بأي شكل من الأشكال نقل، نسخ، أو
            توزيع المحتوى أو جزء منه دون موافقة خطية من إدارة الموقع.
          </li>
          <li>
            <strong class="text-warning">إلتزامات المستخدم:</strong> أي استخدام غير قانوني أو غير
            مصرح به للموقع، بما في ذلك الوصول دون إشتراك، يجعل المستخدم مخالفاً
            وعرضة للمسائلة القانونية.
          </li>
          <li>
            <strong class="text-warning">المشاركة والخصوصية:</strong> مشاركة معلومات الدخول أو
            الروابط المتعلقة بالإشتراك مع أطراف غير مسجلة تعد تجاوزاً لحقوق
            الموقع وقد يترتب عليها إجراءات قانونية.
          </li>
        </ol>
      </div>
    </div>
  </MainLayout>
</template>
